(function(algolia) {
  'use strict';
  algolia.translations = {
    search: 'Your search',
    noCollectionFound: 'No collections found',
    allProducts: 'Show all products',
    matching: 'matching',
    sortBy: 'Sort by:',
    relevance: 'Relevance',
    outOf: '/',
    resultsFound: 'results',
    oneResultFound: '1 result',
    noResultFound: 'No results found',
    addToCart: 'Buy!',
    searchForProduct: 'Search for product',
    selectedFilter: 'Selected filters',
    clearAll: 'Clear filters',
    noPageFound: 'No pages found',
    noArticleFound: 'No articles found',
    outOfStock: 'View product',
    searchTitle: 'Search',
    filters: 'Filters'
  };

  algolia.translation_helpers = {
    no_result_for: function(text, render) {
      return 'No result for ' + render(text);
    },
    productGroups: function() {
      return 'Product groups';
    },
    articles: function() {
      return 'Articles';
    },
    pages: function() {
      return 'Pages';
    },
    /*
    in: function() {
      return '- ajassa ' + this.processingTimeMS / 1000 + 's';
    },*/

    try_clear_or_change_input: function(text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);
      return (
        'Try ' +
        render(html_tags[0]) +
        ' changing input ' +
        render(html_tags[1]) +
        ' or ' +
        render(html_tags[2]) +
        ' clear input ' +
        render(html_tags[3])
      );
    },

    outOf: function() {
      return (
        this.page * this.hitsPerPage +
        1 +
        '-' +
        Math.min((this.page + 1) * this.hitsPerPage, this.nbHits) +
        ' /'
      );
    },

    by: function(text, render) {
      return 'by ' + render(text);
    },

    translation: function(text, render) {
      return algolia.translations[render(text)];
    },
  };
})(window.algoliaShopify);